module.exports = __webpack_public_path__ + "media/app/assets/races/dark_iron_dwarf_female-7757a95a8a362758bbba40f9d5a70a02.png";